import { RowModule } from "../../../../../component/atoms/RowModule/RowModule.jsx"
import { Card } from "react-bootstrap"
import { CardBody } from "../../../../../_metronic/_partials/controls/index.js"
import React, { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useTranslation } from "react-i18next"
import { fileTypeSplit, stringFormatting } from "../../../../helpers/TextHelper.js"
import { DATE_TYPE_ENUM, LABELING_CONST } from "../../../../../constants/StringConstant.js"
import { capitalize } from "@material-ui/core/utils"
import { FileList } from "../../../../../component/index.jsx"
import { timeStampToDate } from "../../../../helpers/DateHelper.js"
import {
  clearMitraStatusHistory,
  getMitraStatusHistory
} from "../../../../../redux/actions/MitraAction.jsx"
import SVG from "react-inlinesvg"
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers/index.js"
import { ILLUSTRATION_CONSTANTS } from "../../../../../constants/ImageConstants.js"

export function StatusHistoryTab({ id }) {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const { Mitra } = useSelector((state) => state)
  const statusLogs = Mitra.statusHistory

  useEffect(() => {
    if (id) {
      dispatch(getMitraStatusHistory(id))
    }
    return () => {
      dispatch(clearMitraStatusHistory())
    }
  }, [dispatch, id])

  const emptyState = (
    <div className={"d-flex flex-column align-items-center"}>
      <SVG src={toAbsoluteUrl(ILLUSTRATION_CONSTANTS.MITRA.EMPTY_STATE_LOG)} />
      <div className={"mt-6 font-size-h5 font-weight-bolder"}>
        {t("messages_response_no_status_history_yet")}
      </div>
    </div>
  )

  return (
    <>
      <RowModule>
        <Card>
          <CardBody>
            {statusLogs && statusLogs.length > 0
              ? statusLogs.map((item, index) => {
                  return (
                    <div key={index} className={"log-file align-items-center"}>
                      <div className={"w-full d-flex justify-content-between"}>
                        <div className={"mb-2"}>
                          <div
                            className={`font-weight-bolder h4 d-flex flex-column ${
                              index === 0 ? "text-mtt-black" : "text-mtt-gray"
                            }`}>
                            {item.status === LABELING_CONST.ACTIVE
                              ? t("activated_mitra")
                              : item.status === LABELING_CONST.FREEZE
                              ? t("label_mitra_freeze")
                              : item.status === LABELING_CONST.UNFREEZE
                              ? t("label_mitra_unfreeze")
                              : item.status === LABELING_CONST.BLACKLIST ||
                                item.status === LABELING_CONST.BLACKLISTED
                              ? t("label_mitra_blacklist")
                              : stringFormatting(item.status)}
                          </div>
                          <div className={"font-size-lg text-mtt-gray"}>
                            {timeStampToDate(
                              item.status_updated_at,
                              DATE_TYPE_ENUM.ISO_DATETIME_STRAP
                            )}{" "}
                            | {capitalize(t("by"))} {stringFormatting(item.status_updated_by)}
                          </div>
                        </div>
                      </div>
                      {item.document && (
                        <FileList
                          view={stringFormatting(item.document.url)}
                          className={"w-full"}
                          name={stringFormatting(item.document.name)}
                          size={stringFormatting(item.document.size)}
                          type={fileTypeSplit(stringFormatting(item.document.name))}
                          rightComponent={
                            <a
                              className={"link"}
                              onClick={() => window.open(item.document.url, "_blank")}>
                              {t("see")}
                            </a>
                          }
                        />
                      )}
                      {item.reason && (
                        <div className={"mt-2"}>
                          <div className={"font-size-base text-mtt-gray font-weight-bold"}>
                            {t("label_reason_status_change")}
                          </div>
                          <div className={"font-size-lg"}>{stringFormatting(item.reason)}</div>
                        </div>
                      )}
                    </div>
                  )
                })
              : emptyState}
          </CardBody>
        </Card>
      </RowModule>
    </>
  )
}
